import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goatourpackagefrompune() {



  const cardData =
  {
    keyword: 'Goa Tour Package From Pune by Bus ',
    heading: 'Sanavi Travels: Goa Tour Package From Pune by Bus',
    headingDescription: 'Sanavi Travels offers reliable Pune to Gujarat Bus Hire Package, providing safe, comfortable, and hassle-free long-distance travel for families, corporate groups, tourists, and tour operators traveling from Pune to Gujarat. Our fleet of AC and Non-AC buses ranging from 32, 35, 40, 45, to 50 seaters, along with tempo travellers on request, is well-maintained and equipped with spacious seating, air-conditioned comfort, and ample luggage space to ensure a relaxed and enjoyable journey. With experienced long-route drivers, flexible one-way and round-trip hire options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees a smooth, timely, and comfortable travel experience. We provide convenient doorstep pickup across Pune—including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station—covering popular Gujarat destinations such as Ahmedabad, Surat, Rajkot, Vadodara, Gir National Park, Somnath, Dwarka, and Saputara. Choose Sanavi Travels for a trusted Pune to Gujarat bus hire package, ensuring safety, comfort, and a memorable group travel experience.',

    top: 'Top Places to Visit in Goa with Sanavi Travels',


"topPlaces": [
  {
    "title": "Gir National Park",
    "description": "Gir National Park is the sole natural habitat of the Asiatic lion and a premier wildlife sanctuary in Gujarat. The park features dry deciduous forests, grasslands, and diverse fauna including leopards, striped hyenas, and antelopes. Safari tours provide close encounters with wildlife amidst scenic landscapes. Gir National Park symbolizes Gujarat’s rich biodiversity and conservation efforts."
  },
  {
    "title": "Somnath Temple",
    "description": "Somnath Temple, located on the Arabian Sea coast, is one of the twelve Jyotirlingas of Lord Shiva. The temple has been reconstructed several times and showcases magnificent Chalukya-style architecture. Pilgrims and tourists visit for spiritual solace and to witness evening aartis by the sea. Somnath Temple represents devotion, resilience, and Gujarat’s religious heritage."
  },
  {
    "title": "Dwarka",
    "description": "Dwarka is an ancient city and one of the Char Dham pilgrimage sites of India, dedicated to Lord Krishna. The Dwarkadhish Temple, situated along the Gomti River, is a major spiritual and architectural landmark. Festivals like Janmashtami attract thousands of devotees. Dwarka symbolizes mythology, devotion, and Gujarat’s cultural richness."
  },
  {
    "title": "Rann of Kutch",
    "description": "The Rann of Kutch is a vast salt marsh in Gujarat, famous for its surreal white landscapes and seasonal salt desert. The Rann Utsav festival celebrates local culture, handicrafts, and folk music. Sunrise and sunset over the white salt flats create magical views. Rann of Kutch represents Gujarat’s natural wonders and vibrant traditions."
  },
  {
    "title": "Saputara",
    "description": "Saputara is Gujarat’s only hill station, located in the Sahyadri range. Surrounded by lush forests and hills, it offers attractions like Saputara Lake, Sunset Point, and tribal cultural centers. Boating, trekking, and nature walks make it a perfect getaway. Saputara symbolizes serenity, greenery, and adventure in Gujarat."
  },
  {
    "title": "Lothal",
    "description": "Lothal is an important archaeological site from the Indus Valley Civilization, showcasing ancient dockyards, bead-making, and trade practices. Excavations reveal urban planning, drainage systems, and artifacts from 2400 BCE. Lothal provides deep insights into Gujarat’s historical and cultural legacy."
  },
  {
    "title": "Palitana Temples",
    "description": "Palitana Temples are a sacred Jain pilgrimage complex situated on Shatrunjaya Hill, consisting of over 900 marble temples. The hilltop temples feature intricate carvings, white marble domes, and a spiritually charged environment. Devotees climb thousands of steps as a ritual of devotion. Palitana Temples represent faith, artistry, and religious dedication."
  },
  {
    "title": "Modhera Sun Temple",
    "description": "The Modhera Sun Temple, dedicated to Surya, the Sun God, is a 11th-century architectural marvel. Known for its intricately carved stepwell (Kunda) and stunning stone sculptures, the temple is aligned with the sun so that sunlight illuminates the sanctum during equinox. Modhera Temple reflects Gujarat’s rich temple architecture and astronomical precision."
  },
  {
    "title": "Akshardham Temple – Gandhinagar",
    "description": "Akshardham Temple in Gandhinagar is a modern architectural and spiritual marvel. Built with intricately carved sandstone and marble, it features exhibitions, gardens, and musical fountains. The temple showcases Indian culture, spirituality, and craftsmanship. Akshardham is a major attraction for devotees and tourists alike."
  },
  {
    "title": "Mandvi Beach",
    "description": "Mandvi Beach, located on the Arabian Sea, is known for its clean sand, gentle waves, and historical Vijay Vilas Palace nearby. The beach is ideal for leisure, kite flying, and enjoying local seafood. Sunset views add to its charm. Mandvi Beach offers a perfect blend of relaxation and cultural heritage in Gujarat."
  }
]
,





"services": [
    {
      "name": "Pune to Gujarat Bus Hire Package",
      "description": "Pune to Gujarat Bus Hire Package offers well-organized and comfortable bus travel for tourists and groups traveling from Pune to Gujarat. Ideal for family holidays, religious tours, and group trips, this service ensures spacious seating, safe long-distance travel, and professional drivers for a smooth and enjoyable journey."
    },
    {
      "name": "Gujarat Tour Bus from Pune",
      "description": "Gujarat Tour Bus from Pune provides reliable bus services for sightseeing and multi-city tours across Gujarat. Well-maintained buses and experienced chauffeurs ensure comfortable travel while visiting popular destinations, cultural landmarks, and tourist attractions throughout the state."
    },
    {
      "name": "AC Bus Pune to Gujarat",
      "description": "AC Bus Pune to Gujarat offers air-conditioned buses for relaxed and comfortable long-distance travel. Ideal for families and group tours, these buses provide spacious interiors, ample luggage space, and professional drivers to ensure a stress-free journey."
    },
    {
      "name": "Luxury Bus Gujarat Tour",
      "description": "Luxury Bus Gujarat Tour provides premium buses with comfortable seating and modern amenities for an enhanced travel experience. Perfect for luxury holidays, corporate groups, or special tours, this service combines elegance, safety, and convenience throughout the Gujarat trip."
    },
    {
      "name": "Family Gujarat Bus Trip",
      "description": "Family Gujarat Bus Trip is designed for families traveling together to explore Gujarat. Comfortable seating, smooth driving, and professional chauffeurs ensure a safe and pleasant holiday experience for passengers of all age groups."
    },
    {
      "name": "Group Travel Gujarat Bus",
      "description": "Group Travel Gujarat Bus caters to large groups, tour operators, and organizations planning trips to Gujarat. Spacious buses and skilled drivers ensure coordinated travel, punctual schedules, and a smooth group touring experience."
    },
    {
      "name": "Affordable Gujarat Bus Package",
      "description": "Affordable Gujarat Bus Package offers budget-friendly tour solutions without compromising on comfort or safety. Ideal for cost-conscious travelers, this service provides reliable buses, experienced drivers, and transparent pricing for Gujarat tours."
    },
    {
      "name": "Chauffeur Driven Gujarat Bus",
      "description": "Chauffeur Driven Gujarat Bus provides professional drivers experienced in long-distance and interstate travel. Passengers can relax while enjoying safe, punctual, and hassle-free journeys across Gujarat’s cities and tourist destinations."
    },
    {
      "name": "Best Gujarat Tour Bus Pune",
      "description": "Best Gujarat Tour Bus Pune offers top-quality buses and professional service for a superior travel experience. Known for reliability, comfort, and disciplined scheduling, this service is ideal for families, groups, and tourists traveling from Pune to Gujarat."
    },
    {
      "name": "Pune Gujarat Travel Bus",
      "description": "Pune Gujarat Travel Bus provides dependable long-distance transport between Pune and Gujarat. Spacious seating, luggage-friendly interiors, and skilled drivers ensure a smooth and comfortable journey for all travelers."
    },
    {
      "name": "Tourist Bus Hire Gujarat",
      "description": "Tourist Bus Hire Gujarat offers buses for sightseeing and guided tours across Gujarat. Ideal for visiting temples, heritage sites, beaches, and cultural attractions, this service ensures comfort, safety, and professional travel support."
    },
    {
      "name": "Long Distance Bus Tour Pune",
      "description": "Long Distance Bus Tour Pune specializes in extended journeys from Pune to destinations like Gujarat. Comfortable buses, professional chauffeurs, and well-planned routes ensure relaxed and enjoyable long-distance travel."
    },
    {
      "name": "Religious Gujarat Tour Bus",
      "description": "Religious Gujarat Tour Bus provides bus services for spiritual and pilgrimage tours across Gujarat. Suitable for temple visits and religious groups, this service ensures safe travel, comfortable seating, and well-coordinated tour schedules."
    },
    {
      "name": "Holiday Bus Package Pune",
      "description": "Holiday Bus Package Pune offers organized bus tours for vacations and leisure travel to Gujarat. Designed for convenience and comfort, this service is ideal for families, friends, and group holiday planners."
    },
    {
      "name": "Gujarat Trip Bus Service",
      "description": "Gujarat Trip Bus Service provides reliable and comfortable buses for complete Gujarat tours. With professional drivers, spacious seating, and efficient planning, this service ensures a smooth, safe, and memorable travel experience."
    }
  ],
  "tableData": [
    ["Pune to Gujarat Bus Hire Package", "Gujarat Tour Bus from Pune"],
    ["AC Bus Pune to Gujarat", "Luxury Bus Gujarat Tour"],
    ["Family Gujarat Bus Trip", "Group Travel Gujarat Bus"],
    ["Affordable Gujarat Bus Package", "Chauffeur Driven Gujarat Bus"],
    ["Best Gujarat Tour Bus Pune", "Pune Gujarat Travel Bus"],
    ["Tourist Bus Hire Gujarat", "Long Distance Bus Tour Pune"],
    ["Religious Gujarat Tour Bus", "Holiday Bus Package Pune"],
    ["Gujarat Trip Bus Service", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Gujarat Bus Hire Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides comfortable and reliable bus hire packages from Pune to Gujarat, ideal for group tours, family trips, corporate travel, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-serviced buses with ample seating and luggage space, ensuring a smooth journey from Pune to Gujarat."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Travel",
    "WhyChoosedescription": "Our professional drivers are experienced in Pune-Gujarat routes, ensuring timely, safe, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront pricing for Pune to Gujarat bus hire packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our team is available round the clock to assist with bookings, travel inquiries, and itinerary planning for your Gujarat trip."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus hire packages according to your travel schedule and group requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene during long-distance travel."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Gujarat bus trips."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer bus hire packages from Pune to Gujarat?',
    answer: 'Yes, Sanavi Travels provides well-maintained and comfortable buses for group travel from Pune to Gujarat.'
  },
  {
    question: 'How can I book a Pune to Gujarat bus hire package with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of buses are used for the Pune to Gujarat trip?',
    answer: 'We provide air-conditioned and well-maintained buses suitable for long-distance group travel.'
  },
  {
    question: 'Are drivers included in the bus hire package?',
    answer: 'Yes, all packages include experienced and professional drivers familiar with Pune-Gujarat routes.'
  },
  {
    question: 'Is the service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel assistance.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey to ensure passenger safety.'
  },
  {
    question: 'Can I customize the Pune to Gujarat bus hire package?',
    answer: 'Absolutely. Sanavi Travels offers customized packages according to your travel and group requirements.'
  },
  {
    question: 'What payment options are available for the bus hire package?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the trip?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Gujarat journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Manoj Patil',
    feedback: 'Booked the Pune to Gujarat bus hire package with Sanavi Travels. Very comfortable, on-time service, and professional driver. Highly recommended!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anjali Kulkarni',
    feedback: 'Excellent experience! The bus was spacious, AC worked perfectly, and the journey was smooth. Sanavi Travels made our Gujarat trip memorable.',
    rating: 5
  }
];









































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goa Tour Package From Pune by Bus - Sanavi Travels",
  "description": "Goa tour package from Pune by bus with Sanavi Travels for family trips, group travel, and holiday tours. Choose AC and luxury buses for safe, comfortable, and affordable travel from Pune to Goa.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1750"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Goa Tour Package From Pune by Bus Starting from ₹50 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Goa tour packages from Pune with Sanavi Travels. AC and luxury buses for family trips, group travel, and holiday tours at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/30.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Goatourpackagefrompune;